// src/Dashboard/pages/admin/Attendance/components/AttendanceStats.jsx
import React from "react";
import {
  FaClipboardCheck,
  FaMinusCircle,
  FaUserCheck,
  FaUserTimes,
  FaUsers,
} from "react-icons/fa";

import { formatNumber } from "../utils/attendanceUtils";

const statCards = [
  {
    key: "total",
    label: "Adhérents",
    helper: "Dans le groupe",
    icon: FaUsers,
    tone: "bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-300",
    format: formatNumber,
  },
  {
    key: "present",
    label: "Présents",
    helper: "Marqués présents",
    icon: FaUserCheck,
    tone:
      "bg-emerald-50 text-emerald-600 dark:bg-emerald-500/10 dark:text-emerald-300",
    format: formatNumber,
  },
  {
    key: "absent",
    label: "Absents",
    helper: "Marqués absents",
    icon: FaUserTimes,
    tone: "bg-rose-50 text-rose-600 dark:bg-rose-500/10 dark:text-rose-300",
    format: formatNumber,
  },
  {
    key: "neutral",
    label: "Non saisis",
    helper: "À compléter",
    icon: FaMinusCircle,
    tone: "bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300",
    format: formatNumber,
  },
  {
    key: "completion",
    label: "Appel rempli",
    helper: "Présents + absents",
    icon: FaClipboardCheck,
    tone:
      "bg-orange-50 text-orange-600 dark:bg-orange-500/10 dark:text-orange-300",
    format: (value) => `${formatNumber(value)}%`,
  },
];

export default function AttendanceStats({ loading, stats }) {
  return (
    <section className="grid gap-4 sm:grid-cols-2 xl:grid-cols-5">
      {statCards.map((card) => {
        const Icon = card.icon;

        return (
          <article
            key={card.key}
            className="rounded-3xl border border-slate-200 bg-white p-5 shadow-sm shadow-slate-200/60 transition hover:-translate-y-1 hover:shadow-lg hover:shadow-slate-200/80 dark:border-slate-800 dark:bg-slate-900 dark:shadow-none"
          >
            <div className="flex items-start justify-between gap-3">
              <div>
                <p className="text-sm font-medium text-slate-500 dark:text-slate-400">
                  {card.label}
                </p>

                {loading ? (
                  <div className="mt-3 h-8 w-16 animate-pulse rounded-xl bg-slate-100 dark:bg-slate-800" />
                ) : (
                  <p className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
                    {card.format(stats?.[card.key])}
                  </p>
                )}

                <p className="mt-2 text-xs text-slate-500 dark:text-slate-400">
                  {card.helper}
                </p>
              </div>

              <span
                className={`grid h-11 w-11 shrink-0 place-items-center rounded-2xl ${card.tone}`}
              >
                <Icon />
              </span>
            </div>
          </article>
        );
      })}
    </section>
  );
}